import { useMemo } from 'react';
import useStadiumGame from '../../hooks/useStadiumGame';
import _ from 'lodash';
import { DEPARTING, RETURNING } from './constants';

const typeNameFilter = typename => item => item.__typename === typename;

const usePersistedOrderOptions = flightsQuery => {
  const persistedFlightOptions = useMemo(() => {
    return getPersistedFlightOptions(flightsQuery.data);
  }, [flightsQuery.data]);

  const [stadiumGame] = useStadiumGame();

  const isPersistedShow = useMemo(() => {
    return isPersistedShows(flightsQuery.data, stadiumGame);
  }, [flightsQuery.data, stadiumGame]);

  const orderItemIds = useMemo(() => {
    return getOrderItemIds(flightsQuery.data);
  }, [flightsQuery.data]);

  return useMemo(
    () => ({
      persistedFlightOptions,
      orderItemIds,
      isPersistedShow,
    }),
    [persistedFlightOptions, orderItemIds, isPersistedShow]
  );
};

const getPersistedFlightOptions = queryData => {
  const persistedFlights = {
    [DEPARTING]: queryData?.order?.items[0],
    [RETURNING]:
      queryData?.flights[RETURNING].length &&
      queryData?.order?.items[1]?.__typename === 'FlightOrderItem'
        ? queryData?.order?.items[1]
        : undefined,
  };

  const getPersistedFlightOption = leg =>
    queryData?.flights[leg].find(flightOption => {
      return flightOption.flight.id === persistedFlights[leg]?.flight.id;
    });

  return {
    [DEPARTING]: getPersistedFlightOption(DEPARTING),
    [RETURNING]: getPersistedFlightOption(RETURNING),
  };
};

const isPersistedShows = (queryData, stadiumGame) => {
  const lastSelectedSeats = [],
    currentSelectedSeats = Array.isArray(stadiumGame?.seatIds)
      ? stadiumGame?.seatIds
      : [];

  const selectedShowsFromQuery = queryData?.order?.items?.filter(
    typeNameFilter('ShowOrderItem')
  );

  _.each(selectedShowsFromQuery, show => {
    lastSelectedSeats.push(show.show.categoryCode);
  });

  return _.isEqual(lastSelectedSeats.sort(), currentSelectedSeats.sort());
};

const getOrderItemIds = queryData => {
  return queryData?.order?.items?.map(item => item.id);
};

export default usePersistedOrderOptions;
